
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol id=\"left_chevron_jax_722a67a1b27bf50548a85d1f233522cc\" ><path d=\"M13.252 15.502c.308.291.333.789.055 1.112a.725.725 0 0 1-1.059.059l-7.5-7.088a.814.814 0 0 1 0-1.17l7.5-7.088a.725.725 0 0 1 1.06.059.815.815 0 0 1-.056 1.112L6.372 9l6.88 6.502z\" fill=\"#2A2A2A\"/><mask id=\"left_chevron_jax_722a67a1b27bf50548a85d1f233522cc_a\" maskUnits=\"userSpaceOnUse\" x=\"4\" y=\"1\" width=\"10\" height=\"16\"><path d=\"M13.252 15.502c.308.291.333.789.055 1.112a.725.725 0 0 1-1.059.059l-7.5-7.088a.814.814 0 0 1 0-1.17l7.5-7.088a.725.725 0 0 1 1.06.059.815.815 0 0 1-.056 1.112L6.372 9l6.88 6.502z\" fill=\"#fff\"/></mask></symbol>";
module.exports = sprite.add(image, "left_chevron_jax_722a67a1b27bf50548a85d1f233522cc");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left_chevron.svg
// module id = 155
// module chunks = 1